<div class='container'>
  <h2>Reset Password</h2>
  <form [hidden]='emailSent' [formGroup]='resetPasswordForm' (ngSubmit)='onSubmit()'>
    <div class='form-group'>
      <label for='email'>Email</label>
      <input type='email' formControlName='email' id='email' class='form-control'
             [ngClass]="{ 'is-invalid': submitted && f.email.errors || errorMessage}"/>
      <div *ngIf='submitted && f.email.errors' class='invalid-feedback'>
        <div *ngIf='f.email.errors.required'>Email is required</div>
        <div *ngIf='f.email.errors.pattern'>Email is invalid</div>
      </div>
      <div *ngIf='errorMessage' class='invalid-feedback d-block'>{{errorMessage}}</div>

    </div>
    <div class='form-group'>
      <button [disabled]='loading' class='btn btn-primary'>
        <span *ngIf='loading' class='spinner-border spinner-border-sm mr-1'></span>
        Reset Password
      </button>
      <a routerLink='/' class='btn btn-link'>Cancel</a>
    </div>

  </form>
  <div [hidden]='!emailSent'
       class='alert alert-success'>Reset link sent! Check your email for instructions on resetting your password.
  </div>
</div>
